<template>
    <div class="p-user-categories">
        <div class="card mb-3">
            <div class="card">
                <div class="card-header">{{ $locale.patient }}区分一覧</div>
                <div class="card-body p-user_categories__content">
                    <div :class="{ 'u-loader u-loader--p5' : ! userCategories }">
                        <div v-if="userCategories">
                            <div class="text-right">
                                <button
                                    type="button"
                                    class="btn btn-yokumiru-orange mb-3"
                                    style="min-width: 100px;"
                                    @click="showModalAdd">追加
                                </button>
                            </div>

                            <b-table
                                striped
                                hover
                                :items="userCategories"
                                :fields="fields"
                                :responsive="true"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :sort-compare="sortCompare"
                                @sort-changed="fetchUserCategories"
                                class="table-bordered m-table">
                                <template v-slot:cell(name_kana)="data">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>{{ data.item.name }}</div>
                                        <div class="d-flex justify-end">
                                            <select
                                                v-model="data.item.flg_show"
                                                class="form-control form-control-sm"
                                                style="width:80px;"
                                                @change="update(data.item)"
                                                :disabled="!canHide(data.item)">
                                                <option value="1">表示</option>
                                                <option value="0">非表示</option>
                                            </select>
                                            <b-button
                                                v-if="Number(data.item.flg_deletable) === 1"
                                                type="button"
                                                class="btn btn-danger btn-sm ml-2"
                                                :class="{ 'disabled' : !deletable(data.item) }"
                                                style="width:80px;"
                                                @click="showModalDelete(data.item)">削除
                                            </b-button>
                                        </div>
                                    </div>
                                </template>
                            </b-table>

                            <div class="mt-3 d-flex justify-content-between align-items-center">
                                <b-pagination
                                    :total-rows="paginationConf.totalRows"
                                    :per-page="paginationConf.perPage"
                                    v-model="paginationConf.currentPage"
                                    @change="fetchUserCategories">
                                </b-pagination>

                                <div class="mb-3 mr-2">
                                    <span class="small">{{ dispPaginationDetail }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <add-user-category-modal/>
        <delete-user-category-modal/>
        <cannot-delete-user-category-modal/>
    </div>
</template>

<script>
import constants from '../../../constants'

export default {
    data: function() {
        return {
            userCategories: null,
            orders: constants.orders,
            sortBy: 'id',
            sortDesc: false,
            paginationConf: {
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
                from: 0,
                to: 0,
            },
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'name_kana',
                    'label': `${this.$locale.patient}区分名`,
                    sortable: true,
                },
            ],
        };
    },

    created: function () {
        this.initQuery()
        this.fetchUserCategories()
        bus.$on('fetch-user-categories', this.fetchUserCategories)
    },

    beforeDestroy: function() {
        bus.$off('fetch-user-categories')
    },

    methods: {
        /**
         * QueryString初期化
         * バリデーションはLaravel側を参照
         *
         * @see App\Http\Requests\Admin\UserCategoriesIndexRequest::rules()
         */
        initQuery: function() {
            this.sortBy = this.$route.query.sort || 'id';
            this.sortDesc = this.$route.query.desc !== 'true';
            this.paginationConf.currentPage = Number( this.$route.query.page ) || 1;
        },

        /**
         * QueryString更新
         *
         * @param {object} ctx
         */
        updateQuery: function ( ctx ) {
            if ( ctx !== null && ctx.hasOwnProperty( 'sortBy' ) ) {
                this.sortBy = ctx.sortBy;
                this.sortDesc = ctx.sortDesc;
            }

            this.$router.replace( {
                path: this.$route.path,
                query: {
                    sort: this.sortBy,
                    desc: this.sortDesc,
                    page: this.paginationConf.currentPage,
                },
            } ).catch(error => {});
        },

        /**
         * 患者区分一覧
         *
         * @param {number|object} param
         */
        fetchUserCategories: function ( param = null ) {
            this.userCategories = null;

            if ( Number.isInteger( param ) && param > 0 ) {
                this.paginationConf.currentPage = param;
            }

            this.updateQuery( param );
            const endpoint = constants.admin.user_categories.endpoint.base;

            axios.get( `${endpoint}${this.buildQuery}&edit=1` )
                .then( ({data}) => {
                    this.userCategories = data.data;
                    this.paginationConf.perPage = data.per_page;
                    this.paginationConf.totalRows = data.total;
                    this.paginationConf.from = data.from;
                    this.paginationConf.to = data.to;
                } );
        },

        /**
         * [bootstrap-vue]
         * テーブルソート
         *
         * @param a
         * @param b
         * @param key
         *
         * @return {boolean}
         */
        sortCompare: function ( a, b, key ) {
            if ( typeof a[key] === 'number' && typeof b[key] === 'number' ) {
                return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0);
            }
            else {
                let valueA = a[key];
                let valueB = b[key];

                return this.toString(valueA).localeCompare(this.toString(valueB), undefined, {
                    numeric: true
                });
            }
        },

        /**
         * 文字列比較（テーブルソート用）
         *
         * @param v
         * @return {string}
         */
        toString: function( v ) {
            if (!v) {
                return ''
            }
            if (v instanceof Object) {
                return keys(v)
                    .map(k => toString(v[k]))
                    .join(' ')
            }
            return String(v)
        },

        /**
         * 追加モーダル表示
         */
        showModalAdd: function () {
            bus.$emit('open-modal-add-user-category')
        },

        /**
         * 削除モーダル表示
         *
         * @param {object} userCategory
         */
        showModalDelete: function (userCategory) {
            if (this.deletable(userCategory)) {
                bus.$emit('open-modal-delete-user-category', userCategory)
            }
            else {
                bus.$emit('open-modal-cannot-delete-user-category')
            }
        },

        /**
         * 患者区分の削除可能判定
         *
         * @param {object} userCategory
         */
        deletable: function (userCategory) {
            return Number(userCategory.flg_deletable) === 1 && userCategory.users_count < 1
        },

        /**
         * 診療科の表示／非表示変更可能判定
         *
         * @param {object} userCategory
         */
        canHide: function (userCategory) {
            return userCategory.users_count < 1
        },

        /**
         * 表示／非表示フラグの更新
         *
         * @param {object} userCategory
         */
        update: function (userCategory) {
            const endpoint = `${constants.admin.user_categories.endpoint.base}/${userCategory.id}`
            const data = { flg_show: userCategory.flg_show }
            axios.put(endpoint, data)
        },
    },

    computed: {
        /**
         * QueryString生成
         *
         * @return {string}
         */
        buildQuery: function () {
            let query = `?page=${this.paginationConf.currentPage}`;
            query += `&sort=${this.sortBy}`;
            query += `&desc=${this.sortDesc}`;

            return query;
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if ( this.paginationConf.totalRows < 1 ) {
                return '';
            }

            return `全${this.paginationConf.totalRows}件中 ${this.paginationConf.from}～${this.paginationConf.to}件表示`;
        },
    },
};
</script>
